module.exports = __webpack_public_path__ + "static/media/16UNODC18.44a4c0e5.jpg";